<template>
  <div class="card modal-card is-min-width-700">
    <div class="modal-card-body pd-0">
      <header class="bandeau-modal card-header">
      </header>
      <div class="card-content pd-40px">
        <h4 class="title is-size-3 has-text-centered mgb-6">
          {{$t('general.popUpResizeImg.title')}}
        </h4>
        <div class="columns">
          <div class="column has-text-centered"
               :class="!notUseCropper ? 'is-8' : 'is-12'">
            <vue-cropper v-if="!notUseCropper"
              ref="cropper"
              :aspect-ratio="1/1"
              alt="Source Image"
              preview=".preview"
              :container-style="{
                height: '320px'
              }">
            </vue-cropper>
            <div v-else>
              <img :src="dataFile.blob">
            </div>
          </div>
          <div class="column" v-if="!notUseCropper">
            <div class="preview"></div>
            <p class="has-text-grid-2 is-size-7 has-text-centered">
              {{$t('general.popUpResizeImg.preview')}}
            </p>
          </div>
        </div>
        <div class="buttons">
          <qd-button v-if="!notUseCropper"
            type="is-primary"
            icon-left="magnify-minus"
            class="perfect-round"
            @click.prevent="zoom(-0.2)"/>
          <qd-button v-if="!notUseCropper"
            type="is-primary"
            icon-left="magnify-plus"
            class="perfect-round"
            @click.prevent="zoom(0.2)"/>
        </div>
        <b-checkbox :value="notUseCropper" @input="destroyCroper($event)">
          {{ $t('general.dontUseCropper') }}
        </b-checkbox>
        <b-checkbox
          v-if="canConserveAncienne"
          v-model="conserveAnciennePj">
              {{ $t('general.conserveAnciennePj') }}
        </b-checkbox>
        <div class="buttons mgt-20px">
          <qd-button
            class="is-cancel btn-modal-annuler"
            @click="$parent.close()">
            {{$t('general.button.cancel')}}
          </qd-button>
          <qd-button
            class="is-addOrEdit"
            @click="resiseImg">
            {{$t('general.button.apply')}}
          </qd-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueCropper from 'vue-cropperjs';
import { MAX_TAILLE } from '@/configuration/general/pieceJointeConf';
import compressionFichier from '@/services/piecesJointes/compression';

export default {
  props: {
    dataFile: {
      type: Object,
      required: true,
    },
    noCropper: {
      type: Boolean,
      default: true,
    },
    canConserveAncienne: {
      type: Boolean,
      default: false,
    },
  },
  components: { VueCropper },
  data() {
    return {
      show: false,
      cropImg: '',
      notUseCropper: false,
      conserveAnciennePj: true,
    };
  },
  methods: {
    destroyCroper(value) {
      this.notUseCropper = value;
      if (value) this.$refs.cropper.destroy();
      else {
        this.createFile();
      }
    },
    resiseImg() {
      if (this.canConserveAncienne) {
        this.dataFile.conserveAnciennePj = this.conserveAnciennePj;
      }
      if (this.notUseCropper) {
        this.$emit('img-resize', this.dataFile);
        return;
      }
      const dataUrl = this.$refs.cropper.getCroppedCanvas().toDataURL();
      this.$refs.cropper.getCroppedCanvas({
        maxWidth: MAX_TAILLE,
        maxHeight: MAX_TAILLE,
      }).toBlob(async (blob) => {
        const file = new File(
          [blob],
          this.dataFile.name,
          {
            type: blob.type,
            lastModified: new Date().getTime(),
          },
        );
        const compressed = await compressionFichier(file);
        this.dataFile.blob = dataUrl;
        this.dataFile.compressedFile = compressed;
        this.dataFile.thumb = dataUrl;
        this.dataFile.file = file;
        this.$emit('img-resize', this.dataFile);
      });
    },
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent);
    },
    createFile() {
      const reader = new FileReader();
      reader.readAsDataURL(this.dataFile.file);
      reader.onload = event => {
        this.show = true;
        this.$refs.cropper?.replace(event.target.result);
      };
    },
  },
  mounted() {
    this.createFile();
    this.notUseCropper = this.noCropper;
  },
};
</script>

<style>

</style>
